import React, { useEffect } from "react";
import { ConfigProvider } from "antd";

import { colorTextTitle, backgroundCard } from "../config/constant/color/index";

const SnackBar = ({
  messageSnack,
  openSnack,
  setOpenedSnack,
  isMobileVersion,
}) => {
  const opened = () => {
    var snackbarElement = document.getElementById(
      isMobileVersion ? "snackbar-general-mobile" : "snackbar-general",
    );

    // Add the "show" class to DIV
    snackbarElement.className = "show";

    // After 3 seconds, remove the show class from DIV
    setTimeout(function () {
      snackbarElement.className = snackbarElement.className.replace("show", "");
      setOpenedSnack(false);
    }, 3000);
  };

  useEffect(() => {
    if (openSnack === true) opened();
  }, [openSnack]);

  return (
    <div id={isMobileVersion ? "snackbar-general-mobile" : "snackbar-general"}>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: "Roboto",
          },
        }}
      >
        <div
          style={{
            background: colorTextTitle,
            borderRadius: isMobileVersion ? 10 : 4,
            width: "fit-content",
            color: backgroundCard,
            padding: isMobileVersion ? "8px 12px" : "16px 16px 14px 16px",
            fontSize: "14px",
            maxWidth: isMobileVersion ? "279px" : "100%",
            opacity: isMobileVersion ? 0.7 : 1,
          }}
        >
          {messageSnack}
        </div>
      </ConfigProvider>
    </div>
  );
};

export default SnackBar;
